import type { Project } from '../api/types';

/**
 * Row-tint class (owner request):
 *   срочно → soft red, высокий → lighter red, низкий → light grey,
 *   статус «На поддержке» → light green (overridden by urgent/high —
 *   attention wins over mode).
 * Colours live in theme.css tokens (`--prio-*-bg`, `--support-row-bg`) and are
 * re-mapped for the dark theme there.
 */
export function priorityRowClass(project: Pick<Project, 'priority' | 'status'>): string {
  if (project.priority === 'urgent') return 'project-row--prio-urgent';
  if (project.priority === 'high') return 'project-row--prio-high';
  if (project.status === 'on_support') return 'project-row--support';
  if (project.priority === 'low') return 'project-row--prio-low';
  return '';
}
